import axios from "axios";
import { BACKEND_URL } from "./constant";

export const api = 
  axios.create({
    baseURL: BACKEND_URL
})